'use client';

import React, { useState } from 'react';
import ExploreFurther from './ExploreFurther';

// ─── PLOT 4 MISSING CONTENT ───────────────────────────────────────────────────
// PDF sections between Hadith of Jibril (pages 20-21) and Al-Khabir/Al-Zahir
// Restored verbatim from source document in correct PDF sequence

// ─── AL-HASEEB / AR-RAQIB — POEM ─────────────────────────────────────────────

export function AlHaseebArRaqibSection() {
  return (
    <section
      id="section-al-haseeb-ar-raqib"
      style={{
        background: 'rgba(8,16,24,0.98)',
        borderTop: '1px solid rgba(201,168,76,0.08)',
        padding: '80px 0',
      }}
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="mb-10">
          <p
            className="font-mono text-[9px] tracking-widest uppercase mb-4"
            style={{ color: 'rgba(139,105,20,0.6)' }}
          >
            ◈ Plot 04 · Section 10
          </p>
          <div className="flex items-start gap-6 mb-6">
            <div>
              <h2
                className="font-mono text-3xl md:text-4xl font-black uppercase tracking-tight mb-2"
                style={{ color: '#F5F0E8' }}
              >
                Al-Haseeb · Ar-Raqib
              </h2>
              <p
                className="font-mono text-sm font-black uppercase tracking-widest mb-2"
                style={{ color: 'rgba(201,168,76,0.6)' }}
              >
                The Reckoner · The Watcher
              </p>
              <div className="flex gap-4 mt-2">
                <span
                  style={{
                    fontFamily: "'Amiri', serif",
                    fontSize: 22,
                    color: 'rgba(201,168,76,0.7)',
                    direction: 'rtl',
                  }}
                >
                  الْحَسِيب
                </span>
                <span
                  style={{
                    fontFamily: "'Amiri', serif",
                    fontSize: 22,
                    color: 'rgba(201,168,76,0.5)',
                    direction: 'rtl',
                  }}
                >
                  الرَّقِيب
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Poem */}
        <div
          className="rounded-xl p-8 mb-8"
          style={{
            background: 'rgba(201,168,76,0.04)',
            border: '1px solid rgba(201,168,76,0.15)',
            borderLeft: '4px solid rgba(201,168,76,0.3)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-6"
            style={{ color: 'rgba(201,168,76,0.5)' }}
          >
            ✦ Verse
          </p>
          <div
            className="space-y-2"
            style={{ color: 'rgba(212,197,169,0.8)', fontSize: 15, lineHeight: 2, fontStyle: 'italic' }}
          >
            <p>This life's a worship</p>
            <p>Writ as wind in life's warship</p>
            <p>Stand</p>
            <p>At attention in the static</p>
            <p>Hunched over the wrong bow, reaching for low seas</p>
            <p>Right your heading</p>
            <p>Re-tension your bow, Qiblah ya quiva</p>
            <p>Calculate the airflow, sharpen ya arrow</p>
            <p>Pull back, lets go</p>
            <p>Row</p>
          </div>
        </div>

        {/* ── Explore Further: Names Active · Al-Haseeb · Ar-Raqib ── */}
        <ExploreFurther label="Explore Further — Names Active · Al-Haseeb · Ar-Raqib" accentColor="rgba(201,168,76,0.5)">
          <div
            className="rounded-lg p-4"
            style={{
              background: 'rgba(201,168,76,0.04)',
              border: '1px solid rgba(201,168,76,0.12)',
            }}
          >
            <p
              className="font-mono text-[9px] uppercase tracking-widest mb-2"
              style={{ color: 'rgba(201,168,76,0.5)' }}
            >
              Names Active · Al-Haseeb · Ar-Raqib
            </p>
            <p
              style={{ color: 'rgba(212,197,169,0.55)', fontSize: 12, lineHeight: 1.7 }}
            >
              <span style={{ color: '#c9a84c' }}>Al-Haseeb</span> — The Reckoner; the One Who takes account of all things.{' '}
              <span style={{ color: '#c9a84c' }}>Ar-Raqib</span> — The Watcher; the One Who observes without ceasing. The poem
              orients the caretaker: this life is worship, the heading is the Qiblah, the arrow is the intention. Al-Haseeb
              reckons the trajectory. Ar-Raqib watches the aim.
            </p>
          </div>
        </ExploreFurther>
      </div>
    </section>
  );
}

// ─── TILL ROWS — ECOSYSTEM OBSERVATION ───────────────────────────────────────

export function TillRowsSection() {
  return (
    <section
      id="section-till-rows"
      style={{
        background: 'rgba(6,13,18,0.97)',
        borderTop: '1px solid rgba(201,168,76,0.08)',
        padding: '80px 0',
      }}
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="mb-10">
          <p
            className="font-mono text-[9px] tracking-widest uppercase mb-4"
            style={{ color: 'rgba(139,105,20,0.6)' }}
          >
            ◈ Plot 04 · Section 11
          </p>
          <h2
            className="font-mono text-3xl md:text-4xl font-black uppercase tracking-tight mb-4"
            style={{ color: '#F5F0E8' }}
          >
            Till Rows
          </h2>
        </div>

        <div
          className="space-y-6 mb-10"
          style={{ color: 'rgba(212,197,169,0.75)', fontSize: 15, lineHeight: 1.9 }}
        >
          <p>
            Ecosystem observation through shifted lenses, while glancing back over an unfolded simulation utilizing the
            example of a redeveloped negative, leaning on my interest in photography and the forthcoming development of a
            core utility of this project: The{' '}
            <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Inner Reality Lens'</span>. Concepts unfolding the
            components of this lens were concepts formed by instructive statements developed in the blueprint of an applied
            curriculum.{' '}
            <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Keys to Kulli Haal'</span> —{' '}
            <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Keys to Every State (of Being)'</span>. Imagine a
            fission reactor that deconstructs anything it perceives into relevant metaphysical aspects and beneficial
            knowledge as manifest reactions.
          </p>
        </div>

        {/* Verse */}
        <div
          className="rounded-xl p-8 mb-8"
          style={{
            background: 'rgba(45,122,71,0.04)',
            border: '1px solid rgba(45,122,71,0.15)',
            borderLeft: '4px solid rgba(45,122,71,0.3)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-6"
            style={{ color: 'rgba(45,122,71,0.6)' }}
          >
            ✦ Verse
          </p>
          <div
            className="space-y-2"
            style={{ color: 'rgba(212,197,169,0.8)', fontSize: 15, lineHeight: 2, fontStyle: 'italic' }}
          >
            <p>Swimming in a monument to this performance piece</p>
            <p>That's the performance — peace</p>
            <p>But we can't leave the stage</p>
            <p>Everything that follows</p>
            <p>Is the performance piece</p>
            <p>Till, Till, Hoe, Sew, Harvest</p>
            <p>Inc, Colored by the Sea</p>
            <p>Subhanallah</p>
          </div>
        </div>

        {/* ── Explore Further: IRL Lens Origin ── */}
        <ExploreFurther label="Explore Further — IRL Lens Origin" accentColor="rgba(201,168,76,0.5)">
          <div
            className="rounded-lg p-4"
            style={{
              background: 'rgba(201,168,76,0.04)',
              border: '1px solid rgba(201,168,76,0.12)',
            }}
          >
            <p
              className="font-mono text-[9px] uppercase tracking-widest mb-2"
              style={{ color: 'rgba(201,168,76,0.5)' }}
            >
              IRL Lens Origin
            </p>
            <p style={{ color: 'rgba(212,197,169,0.55)', fontSize: 12, lineHeight: 1.7 }}>
              This passage is the first naming of the{' '}
              <span style={{ color: '#c9a84c' }}>Inner Reality Lens</span> in the letter — a fission reactor that
              deconstructs anything it perceives into relevant metaphysical aspects and beneficial knowledge. The Keys to
              Kulli Haal are the instructive statements that compose its blueprint. Till, Hoe, Sew, Harvest — the
              caretaker's cycle.
            </p>
          </div>
        </ExploreFurther>
      </div>
    </section>
  );
}

// ─── ROPE OF LANGUAGE ─────────────────────────────────────────────────────────

export function RopeOfLanguageSection() {
  return (
    <section
      id="section-rope-of-language"
      style={{
        background: 'rgba(8,16,24,0.98)',
        borderTop: '1px solid rgba(201,168,76,0.08)',
        padding: '80px 0',
      }}
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="mb-10">
          <p
            className="font-mono text-[9px] tracking-widest uppercase mb-4"
            style={{ color: 'rgba(139,105,20,0.6)' }}
          >
            ◈ Plot 04 · Section 12
          </p>
          <h2
            className="font-mono text-3xl md:text-4xl font-black uppercase tracking-tight mb-4"
            style={{ color: '#F5F0E8' }}
          >
            Rope of Language
          </h2>
        </div>

        <div
          className="space-y-6 mb-10"
          style={{ color: 'rgba(212,197,169,0.75)', fontSize: 15, lineHeight: 1.9 }}
        >
          <p>
            Grasp that language itself must be recognized as being indicative of an implicit direction. Inshallah, the
            following notes will be of benefit:
          </p>
          <p>
            Bismillah, is someone 'Arab' because they speak Arabic or because they're from Arabia? Is it called Arabia because the people who live there are'Arab', or because those people speak Arabic? Am I 'English' then, not
            because I live in England but because I speak English? But if the words look and sound a certain way, and the
            way I compose them is particular to my context, it's called 'ebonics' from ebony, black, and phonetics from
            linguistics; language.
          </p>
          <p>
            Is my language ebony, am I speaking 'Black'? Black signifies a lack of color, but my skin, like yours, is
            brown. In my locality, a green leafy thing is called by many names. One such name is 'tree'; however, if I go
            to the corner station where cars gather to refuel and ask for some 'gas'and give a guy $20, he's likely to give me some trees to blow. I could say about that situation that I blew some paper on some'green'. As we recognize more, we're prompted to grow better, transplanting our sense of self into the new soil we seek to
            compose{' '}
            <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>fisabilillah</span>, In the Way of Allah.
          </p>
        </div>

        {/* ── Explore Further: Language as Direction ── */}
        <ExploreFurther label="Explore Further — Language as Direction" accentColor="rgba(201,168,76,0.5)">
          <div
            className="rounded-xl p-6"
            style={{
              background: 'rgba(201,168,76,0.06)',
              border: '1px solid rgba(201,168,76,0.2)',
            }}
          >
            <p
              className="font-mono text-[9px] uppercase tracking-widest mb-3"
              style={{ color: 'rgba(201,168,76,0.5)' }}
            >
              Language as Direction
            </p>
            <p
              style={{
                color: 'rgba(212,197,169,0.8)',
                fontSize: 14,
                lineHeight: 1.85,
                fontStyle: 'italic',
              }}
            >
              "As we recognize more, we're prompted to grow better, transplanting our sense of self into the new soil we seek to compose fisabilillah, In the Way of Allah."
            </p>
          </div>
        </ExploreFurther>
      </div>
    </section>
  );
}

// ─── AMANAH (TRUST) ───────────────────────────────────────────────────────────

export function AmanahTrustSection() {
  return (
    <section
      id="section-amanah-trust"
      style={{
        background: 'rgba(6,13,18,0.97)',
        borderTop: '1px solid rgba(201,168,76,0.08)',
        padding: '80px 0',
      }}
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="mb-10">
          <p
            className="font-mono text-[9px] tracking-widest uppercase mb-4"
            style={{ color: 'rgba(139,105,20,0.6)' }}
          >
            ◈ Plot 04 · Section 13
          </p>
          <div className="flex items-start gap-6 mb-6">
            <div>
              <h2
                className="font-mono text-4xl md:text-5xl font-black uppercase tracking-tight mb-2"
                style={{ color: '#F5F0E8' }}
              >
                Amanah
              </h2>
              <p
                className="font-mono text-sm font-black uppercase tracking-widest mb-2"
                style={{ color: 'rgba(201,168,76,0.6)' }}
              >
                Trust · Belief
              </p>
              <p
                style={{
                  fontFamily: "'Amiri', serif",
                  fontSize: 28,
                  color: 'rgba(201,168,76,0.7)',
                  direction: 'rtl',
                }}
              >
                أَمَانَة
              </p>
            </div>
          </div>

          {/* Root Analysis */}
          <div
            className="rounded-xl p-6 mb-8"
            style={{
              background: 'rgba(139,105,20,0.06)',
              border: '1px solid rgba(139,105,20,0.2)',
            }}
          >
            <p
              className="font-mono text-[9px] uppercase tracking-widest mb-3"
              style={{ color: 'rgba(139,105,20,0.6)' }}
            >
              Root · Hamza - Mim - Nun
            </p>
            <div className="flex flex-wrap gap-2">
              {[
                'A Trust',
                'To feel secure',
                'To believe',
                'Entrusted',
                'Security',
                'Trustworthy',
                'Safe',
              ]?.map((m) => (
                <span
                  key={m}
                  className="font-mono text-[10px] px-2 py-1 rounded"
                  style={{
                    background: 'rgba(139,105,20,0.1)',
                    color: 'rgba(212,197,169,0.7)',
                    border: '1px solid rgba(139,105,20,0.15)',
                  }}
                >
                  {m}
                </span>
              ))}
            </div>
            <p
              className="font-mono text-[10px] mt-3"
              style={{ color: 'rgba(212,197,169,0.45)', lineHeight: 1.6 }}
            >
              The word for 'Trust' shares the same root as the word for 'Belief' — Iman. The essential trust taken by
              humanity is the agency of choice.
            </p>
          </div>
        </div>

        {/* Quran 33:72 */}
        <div
          className="rounded-xl p-6 mb-8"
          style={{
            background: 'rgba(45,122,71,0.06)',
            border: '1px solid rgba(45,122,71,0.2)',
            borderLeft: '3px solid rgba(45,122,71,0.5)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-3"
            style={{ color: 'rgba(45,122,71,0.7)' }}
          >
            Quran 33:72
          </p>
          <p
            style={{
              color: 'rgba(212,197,169,0.8)',
              fontSize: 14,
              lineHeight: 1.85,
              fontStyle: 'italic',
            }}
          >
            "Indeed, We, We offered the Trust to the heavens and the earth and the mountains, but they refused to bear
            it, and they feared from it; but bore it the human being. Indeed, he was unjust, ignorant."
          </p>
        </div>

        {/* Quran 61:1-2 */}
        <div
          className="rounded-xl p-6 mb-8"
          style={{
            background: 'rgba(45,122,71,0.06)',
            border: '1px solid rgba(45,122,71,0.2)',
            borderLeft: '3px solid rgba(45,122,71,0.5)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-3"
            style={{ color: 'rgba(45,122,71,0.7)' }}
          >
            Quran 61:1-2
          </p>
          <p
            style={{
              color: 'rgba(212,197,169,0.8)',
              fontSize: 14,
              lineHeight: 1.85,
              fontStyle: 'italic',
            }}
          >
            "Glorifies Allah whatever in the heavens and whatever in the earth. And He Al-Aziz; The All-Mighty,
            Al-Hakim; The All-Wise. O' who believe, why you say what not you do?"
          </p>
        </div>

        {/* Body Text */}
        <div
          className="space-y-6 mb-10"
          style={{ color: 'rgba(212,197,169,0.75)', fontSize: 15, lineHeight: 1.9 }}
        >
          <p>
            Conscious existence is to see who comes to guidance when called to it. The coming together is based on the
            commonality that we are all created and subject to the instruction of the Creator. The last message was sent
            for all humanity, a sufficient reminder. Signs that pair with the signs already around and inside us. The
            word for 'Trust' shares the same root as the word for 'Belief'. The essential trust taken by humanity is the
            agency of choice. Unlike the rest of creation, we can choose not to abide by the instructions of our
            creator. A river doesn't preplan its flow; it's guided. Before the constitutions were written, mankind was
            given a declaration with clear instructions on how to exist with purpose — aligning with the rest of
            creation.
          </p>
          <p>
            We were sent the reminder; we just need to be reminded. We're travelers here in this world briefly, to
            follow guidance, give thanks, do good work, and take care not to transgress in the balance.
          </p>
          <p>
            Having undertaken the burden of this gift's test, our stage is set with so many beautiful examples, hints,
            and gestures. All pointing, each a potential means of redirecting; a ray of sunlight is indicative of its
            source,{' '}
            <span style={{ color: '#c9a84c' }}>Al-Nur</span>; The Light, of the heavens and the earth. Yet we've grown
            to subconsciously rely on the apparent utility of these proofs more than reflecting on the purpose manifest
            via these Ayat, Signs. Allah guides to His Light whom He pleases.
          </p>
        </div>

        {/* Key phrase */}
        <div
          className="rounded-xl p-8"
          style={{
            background: 'rgba(201,168,76,0.06)',
            border: '1px solid rgba(201,168,76,0.2)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-4"
            style={{ color: 'rgba(201,168,76,0.5)' }}
          >
            The Amanah — The Trust
          </p>
          <p
            style={{
              color: 'rgba(212,197,169,0.8)',
              fontSize: 15,
              lineHeight: 1.9,
              fontStyle: 'italic',
            }}
          >
            "The heavens and the earth and the mountains refused to bear it. The human being bore it." The Amanah is the
            agency of choice — the capacity to choose submission or refusal. The garden is a tool for those who chose to
            bear it.
          </p>
        </div>
      </div>
    </section>
  );
}

// ─── HAQQ — TRUTH, RIGHT, REALITY, PURPOSE ───────────────────────────────────

export function HaqqSection() {
  const [expanded, setExpanded] = useState(false);

  return (
    <section
      id="section-haqq"
      style={{
        background: 'rgba(8,16,24,0.98)',
        borderTop: '1px solid rgba(201,168,76,0.08)',
        padding: '80px 0',
      }}
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="mb-10">
          <p
            className="font-mono text-[9px] tracking-widest uppercase mb-4"
            style={{ color: 'rgba(139,105,20,0.6)' }}
          >
            ◈ Plot 04 · Section 14
          </p>
          <div className="flex items-start gap-6 mb-6">
            <div>
              <h2
                className="font-mono text-4xl md:text-5xl font-black uppercase tracking-tight mb-2"
                style={{ color: '#F5F0E8' }}
              >
                Haqq
              </h2>
              <p
                className="font-mono text-sm font-black uppercase tracking-widest mb-2"
                style={{ color: 'rgba(201,168,76,0.6)' }}
              >
                Truth · Right · Reality · Purpose
              </p>
              <p
                style={{
                  fontFamily: "'Amiri', serif",
                  fontSize: 28,
                  color: 'rgba(201,168,76,0.7)',
                  direction: 'rtl',
                }}
              >
                الْحَقّ
              </p>
            </div>
          </div>
        </div>

        {/* Names cluster */}
        <div
          className="rounded-xl p-6 mb-8"
          style={{
            background: 'rgba(139,105,20,0.06)',
            border: '1px solid rgba(139,105,20,0.2)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-3"
            style={{ color: 'rgba(139,105,20,0.6)' }}
          >
            Names Active in This Section
          </p>
          <div className="flex flex-wrap gap-2">
            {[
              'Al-Raqib — The Watcher',
              'Al-Baseer — The All-Seeing',
              'Al-Khabeer — The All-Aware',
              'Al-Latif — The Subtle',
              'Al-Alim — The All-Knowing',
              'Al-Haqq — The Only Reality',
              'Al-Bari — The Evolver',
              'Ar-Razzaq — The Ever Provider',
              'Al-Haseeb — The Reckoner',
            ]?.map((n) => (
              <span
                key={n}
                className="font-mono text-[10px] px-2 py-1 rounded"
                style={{
                  background: 'rgba(139,105,20,0.1)',
                  color: 'rgba(212,197,169,0.7)',
                  border: '1px solid rgba(139,105,20,0.15)',
                }}
              >
                {n}
              </span>
            ))}
          </div>
        </div>

        {/* Body Text */}
        <div
          className="space-y-6 mb-10"
          style={{ color: 'rgba(212,197,169,0.75)', fontSize: 15, lineHeight: 1.9 }}
        >
          <p>
            So, what is the reality of a 'tree'? Its tree-ness is a state of being, and this state of being, like all
            other states, is of{' '}
            <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>Alhamdulillah</span>; the means of it doing this are
            apparent in the systems that compose its evident tree-ness. It's being created, evolved/grown, formed/molded,
            provided for via a process whereby it receives light from another process driven by the One Who made the sun.
          </p>
          <p>
            Understand the world around you, every thing as{' '}
            <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Haals'</span>, states of being, bridges waiting to
            be drawn back to Allah. These bridged ways are uniquely suited to the self's environment. That environment is
            your sense of self. The logic required to translate that expression into noise is only a small component; the
            main element is what's being translated. Society teaches us a vocabulary that is not necessarily the
            vocabulary that we were originally given. Rather, we are given words that only somewhat match our internal
            environment, and taught to reconstruct an entire environment of self, using these mislabeled utensils to
            recognize our being. Something is lost in translation — let's uncover it.
          </p>
        </div>

        {/* Al-Haqq Name Entry */}
        <div
          className="rounded-xl p-6 mb-8"
          style={{
            background: 'rgba(201,168,76,0.06)',
            border: '1px solid rgba(201,168,76,0.2)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-4"
            style={{ color: 'rgba(201,168,76,0.5)' }}
          >
            Al-Haqq — The Absolute Truth / Reality / Right
          </p>
          <div className="flex items-center gap-4 mb-4">
            <span
              className="font-mono text-2xl font-black uppercase"
              style={{ color: '#F5F0E8' }}
            >
              Al-Haqq
            </span>
            <span
              style={{
                fontFamily: "'Amiri', serif",
                fontSize: 24,
                color: 'rgba(201,168,76,0.7)',
                direction: 'rtl',
              }}
            >
              الْحَقّ
            </span>
          </div>
          <p
            style={{ color: 'rgba(212,197,169,0.65)', fontSize: 13, lineHeight: 1.75 }}
          >
            <span style={{ color: '#c9a84c' }}>Al-Haqq</span> is the Name that grounds all of reality. Haqq is
            simultaneously: Truth (what is real), Right (what is due), Reality (what actually is), and Purpose (what a
            thing is for). When the letter speaks of the 'user interface of existence' — the Dunya presenting itself as
            source code rather than a facilitated view of Ayat — it is describing a departure from Haqq. The platform's
            purpose is to return the caretaker to Haqq: to see things as they are, not as they are presented.
          </p>
        </div>

        {/* Expandable depth */}
        <button
          onClick={() => setExpanded(!expanded)}
          className="font-mono text-[9px] tracking-widest uppercase flex items-center gap-2 transition-all mb-4"
          style={{ color: 'rgba(201,168,76,0.5)', background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <span
            style={{
              display: 'inline-block',
              transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s',
            }}
          >
            ▶
          </span>
          {expanded ? 'Collapse' : 'Haqq — Platform Connections'}
        </button>

        {expanded && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {[
              {
                label: 'IRL Lens',
                desc: 'The IRL Lens reads Haqq — the reality of things as they are, not as they are presented',
                href: '/inner-reality-lens',
                color: '#c9a84c',
              },
              {
                label: 'SL Glossary',
                desc: 'Haqq as a root concept — every term in the glossary points back to Al-Haqq',
                href: '/sl-glossary',
                color: '#8a8ab8',
              },
              {
                label: 'Muslim Resource Guide',
                desc: 'Violations of rights are violations of Haqq — the MRG maps where Haqq is transgressed',
                href: '/muslim-resource-guide',
                color: '#2d7a47',
              },
              {
                label: 'Keys to Kulli Haal',
                desc: 'Key 01: Taqwah — consciousness of Allah is consciousness of Haqq',
                href: '/keys-to-kulli-haal',
                color: '#2d8a87',
              },
            ]?.map((b) => (
              <a
                key={b?.label}
                href={b?.href}
                className="block rounded-xl p-4 transition-all"
                style={{
                  background: `${b?.color}06`,
                  border: `1px solid ${b?.color}20`,
                  textDecoration: 'none',
                }}
              >
                <p
                  className="font-mono text-[10px] font-black uppercase tracking-widest mb-1"
                  style={{ color: b?.color }}
                >
                  {b?.label}
                </p>
                <p style={{ color: 'rgba(212,197,169,0.6)', fontSize: 12, lineHeight: 1.6 }}>
                  {b?.desc}
                </p>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

// ─── AL-KHALIQ — THE CREATOR ──────────────────────────────────────────────────

export function AlKhaliqSection() {
  return (
    <section
      id="section-al-khaliq"
      style={{
        background: 'rgba(6,13,18,0.97)',
        borderTop: '1px solid rgba(201,168,76,0.08)',
        padding: '80px 0',
      }}
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="mb-10">
          <p
            className="font-mono text-[9px] tracking-widest uppercase mb-4"
            style={{ color: 'rgba(139,105,20,0.6)' }}
          >
            ◈ Plot 04 · Section 15 · PDF §34
          </p>
          <div className="flex items-start gap-6 mb-6">
            <div>
              <h2
                className="font-mono text-4xl md:text-5xl font-black uppercase tracking-tight mb-2"
                style={{ color: '#F5F0E8' }}
              >
                Al-Khaliq
              </h2>
              <p
                className="font-mono text-sm font-black uppercase tracking-widest mb-2"
                style={{ color: 'rgba(201,168,76,0.6)' }}
              >
                The Creator
              </p>
              <p
                style={{
                  fontFamily: "'Amiri', serif",
                  fontSize: 28,
                  color: 'rgba(201,168,76,0.7)',
                  direction: 'rtl',
                }}
              >
                الْخَالِق
              </p>
            </div>
          </div>

          {/* Root Analysis */}
          <div
            className="rounded-xl p-6 mb-8"
            style={{
              background: 'rgba(139,105,20,0.06)',
              border: '1px solid rgba(139,105,20,0.2)',
            }}
          >
            <p
              className="font-mono text-[9px] uppercase tracking-widest mb-3"
              style={{ color: 'rgba(139,105,20,0.6)' }}
            >
              Root · Kha - Lam - Qaf
            </p>
            <div className="flex flex-wrap gap-2">
              {[
                'To measure accurately',
                'To determine the proper measure or proportion for something',
                'To proportion one thing according to another',
                'To create something based on a pattern or model which one has devised',
                'To bring a thing into existence from non-existence',
              ]?.map((m) => (
                <span
                  key={m}
                  className="font-mono text-[10px] px-2 py-1 rounded"
                  style={{
                    background: 'rgba(139,105,20,0.1)',
                    color: 'rgba(212,197,169,0.7)',
                    border: '1px solid rgba(139,105,20,0.15)',
                  }}
                >
                  {m}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Quran 59:24 */}
        <div
          className="rounded-xl p-6 mb-6"
          style={{
            background: 'rgba(45,122,71,0.06)',
            border: '1px solid rgba(45,122,71,0.2)',
            borderLeft: '3px solid rgba(45,122,71,0.5)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-3"
            style={{ color: 'rgba(45,122,71,0.7)' }}
          >
            Quran 59:24
          </p>
          <p
            style={{
              color: 'rgba(212,197,169,0.8)',
              fontSize: 14,
              lineHeight: 1.85,
              fontStyle: 'italic',
            }}
          >
            "He, Allah The Creator, The Inventor, The Fashioner. For Him the names the beautiful. Glorifies Him
            whatever in the heavens and the earth. And He the All-Mighty, the All-Wise."
          </p>
        </div>

        {/* Quran 18:45-46 */}
        <div
          className="rounded-xl p-6 mb-6"
          style={{
            background: 'rgba(45,122,71,0.06)',
            border: '1px solid rgba(45,122,71,0.2)',
            borderLeft: '3px solid rgba(45,122,71,0.5)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-3"
            style={{ color: 'rgba(45,122,71,0.7)' }}
          >
            Quran 18:45-46
          </p>
          <p
            style={{
              color: 'rgba(212,197,169,0.8)',
              fontSize: 14,
              lineHeight: 1.85,
              fontStyle: 'italic',
            }}
          >
            "And present to them the example the life the dunya, lowest nearest, like water which We send down from the
            sky, then mingles with vegetation of the earth then becomes dry stalks, its scattered the winds. And Allah
            over every thing is All Able. The wealth and children (are) adornment of the life of dunya, lowest nearest.
            But the enduring good deeds (are) better near your lord (for) reward, and better (for) hope."
          </p>
        </div>

        {/* Quran 2:28-29 */}
        <div
          className="rounded-xl p-6 mb-8"
          style={{
            background: 'rgba(45,122,71,0.06)',
            border: '1px solid rgba(45,122,71,0.2)',
            borderLeft: '3px solid rgba(45,122,71,0.5)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-3"
            style={{ color: 'rgba(45,122,71,0.7)' }}
          >
            Quran 2:28-29
          </p>
          <p
            style={{
              color: 'rgba(212,197,169,0.8)',
              fontSize: 14,
              lineHeight: 1.85,
              fontStyle: 'italic',
            }}
          >
            "How you disbelieve in Allah? While you were dead then He gave you life: then He will cause you to die, then
            He will give you life, then to Him you will be returned. He the One Who created for you what in the earth,
            all. Moreover He turned to the heaven and fashioned them seven heavens. And He of every thing Al-Alim; The
            All-Knowing."
          </p>
        </div>

        {/* Surah Ar-Rahman verses + Zahir passage */}
        <div
          className="rounded-xl p-6 mb-8"
          style={{
            background: 'rgba(45,122,71,0.06)',
            border: '1px solid rgba(45,122,71,0.2)',
            borderLeft: '3px solid rgba(45,122,71,0.5)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-3"
            style={{ color: 'rgba(45,122,71,0.7)' }}
          >
            Surah Ar-Rahman · Quran 55:14-32
          </p>
          <p
            style={{
              color: 'rgba(212,197,169,0.8)',
              fontSize: 14,
              lineHeight: 1.85,
              fontStyle: 'italic',
            }}
          >
            "He created the human being from clay like pottery. And He created the jinn (Spirits) from a smokeless flame
            of fire. So which favors of your Lord will you both deny? Lord the two Easts and Lord the two Wests. So
            which favors of your Lord will you both deny? He released the two seas, meeting. Between both of them a
            barrier, not they transgress. So which favors of your Lord will you both deny? Come forth from both of them
            the pearl and the coral. So which favors of your Lord will you both deny? And for Him the ships elevated in
            the sea like mountains. So which favors of your Lord will you both deny? Everyone who on it perish. But will
            remain Face your lord, Owner Majesty and Honor. So which favors of your Lord will you both deny? Asks Him,
            whoever in the heavens and the earth. Every day He in a matter. So which favors of your Lord will you both
            deny? Soon We will attend to you, O you two classes! So which favors of your Lord will you both deny?"
          </p>
        </div>

        {/* Zahir passage */}
        <div
          className="space-y-6 mb-10"
          style={{ color: 'rgba(212,197,169,0.75)', fontSize: 15, lineHeight: 1.9 }}
        >
          <p>
            There are many dualities in the Ayat of Surah Ar-Rahman; The Most Compassionate; all of them are favors —
            everything in creation is. The{' '}
            <span style={{ color: '#c9a84c', fontStyle: 'italic' }}>'Zahir'</span> — Apparent, manifest Ayat, signs in
            creation around us are reminders; the more we learn via discoveries in various fields like science,
            technology, engineering, and mathematics, the more we uncover what was already there. The reminders in this
            transient, temporary abode are means provided by Allah in this test — life.
          </p>
        </div>

        {/* Quran 25:45 */}
        <div
          className="rounded-xl p-6 mb-8"
          style={{
            background: 'rgba(45,122,71,0.06)',
            border: '1px solid rgba(45,122,71,0.2)',
            borderLeft: '3px solid rgba(45,122,71,0.5)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-3"
            style={{ color: 'rgba(45,122,71,0.7)' }}
          >
            Quran 25:45
          </p>
          <p
            style={{
              color: 'rgba(212,197,169,0.8)',
              fontSize: 14,
              lineHeight: 1.85,
              fontStyle: 'italic',
            }}
          >
            "Don't you see your Lord how He extends the shadow? And if He willed, surely He have made it stationary.
            Then We made the sun for it, an indication."
          </p>
        </div>

        {/* Key phrase */}
        <div
          className="rounded-xl p-8"
          style={{
            background: 'rgba(201,168,76,0.06)',
            border: '1px solid rgba(201,168,76,0.2)',
          }}
        >
          <p
            className="font-mono text-[9px] uppercase tracking-widest mb-4"
            style={{ color: 'rgba(201,168,76,0.5)' }}
          >
            Al-Khaliq · The Creator — Platform Ground
          </p>
          <p
            style={{
              color: 'rgba(212,197,169,0.8)',
              fontSize: 15,
              lineHeight: 1.9,
            }}
          >
            Al-Khaliq creates from a pattern — a blueprint. The Taqdir is the blueprint. The IRL Lens reads the
            blueprint in what has been created. The root Kha-Lam-Qaf contains the same precision as Qaf-Dal-Ra: to
            measure accurately, to proportion one thing according to another. Creation is measured. The Lens reads the
            measurements. The caretaker recognizes the Measurer.
          </p>
        </div>
      </div>
    </section>
  );
}

// ─── PLOT 4 MISSING CONTENT WRAPPER ──────────────────────────────────────────

export default function Plot4MissingContent() {
  return (
    <>
      <AlHaseebArRaqibSection />
      <TillRowsSection />
      <RopeOfLanguageSection />
      <AmanahTrustSection />
      <HaqqSection />
      <AlKhaliqSection />
    </>
  );
}
